import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { movieBrands, getMovieKeyword, exportMovieData } from '@/api/order';
import { getCitys } from '@/api/goodsCenter';
import { getCinemaList, getMoviesList } from '@/views/cardSystem/customer/api';
export default {
  name: 'movieConfig',
  props: {
    order_id: [Number, String],
    currentRowMenu: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    ruleType: String,
    entryType: String,
    // 平台配置  渠道列表 管理中心 订单规则
    /**
     * @description menuType 菜单类型
     * orderDetails - 订单列表-订单详情-订单规则
     * channelCardTypeManage - 管理中心 卡类型管理
     * saleCardTypeManage - 销售工具 卡类型管理
     * customerSet - 客户管理 - 客户列表 - 设置 - 营销参数管理
     */
    menuType: String,
    movieType: String,
    // view - 查看 没有编辑功能  set - 允许编辑
    ruleInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menusInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasEditRule: Boolean,
    movie_white_list_type: [String, Number],
    checkedCityTotal: [String, Number],
    whiteCinemaTotal: [String, Number]
  },
  data: function data() {
    return {
      citys: [],
      searchForm: {
        region_id: '',
        cinema_name: '',
        is_on_shelf: '',
        page: 1,
        pagesize: 20
      },
      totalCount: 0,
      tableData: [],
      exportLoading: false,
      priceRange: [],
      settingsInfo: {
        black_cinema_count: '0',
        movie_setting_type: '0',
        on_cinema_count: '0',
        off_cinema_count: '0'
      },
      dialogType: '',
      customerDialog: false,
      dialogForm: {
        city_id: '',
        cinema_name: '',
        page: 1,
        page_size: 20
      },
      dialogTableData: [],
      dialogTotal: 0,
      keywordTotal: 0
    };
  },
  methods: {
    onDialogClose: function onDialogClose() {
      this.$refs.dialogForm.resetFields();
    },
    searchBlackList: function searchBlackList() {
      var _this$$refs$dialogFor;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = props.type;
      type === 'reset' && ((_this$$refs$dialogFor = this.$refs.dialogForm) === null || _this$$refs$dialogFor === void 0 ? void 0 : _this$$refs$dialogFor.resetFields());
      this.dialogForm.page = page;
      this.getBlackList();
    },
    getBlackList: function getBlackList() {
      var _this = this;
      // 获取影院黑名单 / 影片黑白名单数据
      var req = this.dialogType === 'cinema' ? getCinemaList : getMoviesList;
      var _this$settingsInfo = this.settingsInfo,
        customer_account_id = _this$settingsInfo.account_id,
        customer_id = _this$settingsInfo.customer_id,
        movie_setting_type = _this$settingsInfo.movie_setting_type;
      var params = _objectSpread(_objectSpread({}, this.dialogForm), {}, {
        pagesize: this.dialogForm.page_size,
        customer_id: customer_id,
        customer_account_id: customer_account_id
      }, this.dialogType === 'cinema' ? {
        status: 1
      } : {
        movie_setting_type: movie_setting_type
      });
      req(params).then(function (res) {
        var data = res.data,
          _res$pages = res.pages,
          pages = _res$pages === void 0 ? {} : _res$pages;
        if (_this.dialogType === 'cinema') {
          _this.dialogTableData = data || [];
        } else {
          _this.dialogTableData = (data === null || data === void 0 ? void 0 : data.black_movies) || [];
        }
        _this.dialogTotal = Number(pages.totalCount || 0);
      });
    },
    openDialog: function openDialog(openType) {
      this.dialogType = openType;
      switch (openType) {
        case 'viewMovieKeyword':
        case 'setMovieKeyword':
          this.$emit('openMovieKeyword', this.currentRowMenu, {
            openType: openType
          });
          break;
        case 'viewWhiteMovie':
        case 'setWhiteMovie':
          this.$emit('openWhiteMovie', this.currentRowMenu, {
            openType: openType
          });
          break;
        case 'movie':
        case 'cinema':
          this.searchBlackList();
          this.customerDialog = true;
          break;
      }
    },
    pageChange: function pageChange() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var formName = arguments.length > 1 ? arguments[1] : undefined;
      this[formName].page = page;
      if (formName === 'searchForm') {
        this.getList();
      } else if (formName === 'dialogForm') {
        this.getBlackList();
      }
    },
    sizeChange: function sizeChange(size, formName) {
      this[formName].pagesize = size;
      this.pageChange(1, formName);
    },
    searchData: function searchData(type, formName) {
      type === 'reset' && this.$refs[formName].resetFields();
      this.pageChange(1, formName);
    },
    exportData: function exportData() {
      var _this2 = this;
      this.exportLoading = true;
      exportMovieData(_objectSpread(_objectSpread(_objectSpread({}, this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }), this.searchForm), {}, {
        type: 'allow_brand',
        menu_id: this.currentRowMenu.id
      }), this.menuType).then(function (_) {
        _this2.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      }).finally(function () {
        _this2.exportLoading = false;
      });
    },
    getConfig: function getConfig() {
      var _this3 = this;
      getCitys().then(function (res) {
        _this3.citys = res.data.tree;
      });
    },
    getList: function getList() {
      var _this4 = this;
      return new Promise(function (resolve) {
        movieBrands(_objectSpread(_objectSpread(_objectSpread({}, _this4.ruleType === 'cardType' ? {
          rule_id: _this4.ruleInfo.id
        } : {
          order_id: _this4.order_id
        }), {}, {
          type: 'allow_brand'
        }, _this4.searchForm), {}, {
          menu_id: _this4.currentRowMenu.id
        })).then(function (res) {
          var _res$data = res.data,
            _res$data$data = _res$data.data,
            data = _res$data$data === void 0 ? [] : _res$data$data,
            _res$data$pages = _res$data.pages,
            pages = _res$data$pages === void 0 ? {} : _res$data$pages,
            _res$data$extend_data = _res$data.extend_data,
            extend_data = _res$data$extend_data === void 0 ? {} : _res$data$extend_data;
          _this4.tableData = data;
          _this4.totalCount = Number(pages.total_count || 0);
          var min_price = extend_data.min_price,
            max_price = extend_data.max_price,
            _extend_data$settings = extend_data.settings,
            settings = _extend_data$settings === void 0 ? {} : _extend_data$settings;
          _this4.priceRange = min_price == '0' && max_price == '0' ? ['不限制'] : [min_price, max_price];
          _this4.settingsInfo = _objectSpread({}, settings);
          resolve(res.data);
        });
      });
    },
    getKeywordTotal: function getKeywordTotal() {
      var _this5 = this;
      getMovieKeyword(this.ruleType === 'cardType' ? {
        rule_id: this.ruleInfo.id
      } : {
        order_id: this.order_id
      }).then(function (res) {
        _this5.keywordTotal = res.data.length;
      });
    },
    loadData: function loadData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this6.searchForm.page = 1;
              _this6.getList(); // 获取可用品牌数据
              _this6.getKeywordTotal(); // 获取关键词总数
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.getConfig();
    this.loadData();
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return {
        movie: "\u5F71\u7247".concat(this.settingsInfo.movie_setting_type == '1' ? '黑' : '白', "\u540D\u5355"),
        cinema: '影院黑名单'
      }[this.dialogType];
    },
    whiteCount: function whiteCount() {
      if (this.movie_white_list_type == 1 && this.whiteCinemaTotal) {
        return "\u767D\u540D\u5355\u5F71\u9662\uFF1A".concat(this.whiteCinemaTotal, "\u4E2A");
      } else if (this.movie_white_list_type == 2 && this.checkedCityTotal) {
        return "\u767D\u540D\u5355\u57CE\u5E02\uFF1A".concat(this.checkedCityTotal, "\u4E2A");
      } else {
        return '未设置';
      }
    },
    blackMovieCount: function blackMovieCount() {
      var _this$settingsInfo2 = this.settingsInfo,
        black_movies_count = _this$settingsInfo2.black_movies_count,
        movie_setting_type = _this$settingsInfo2.movie_setting_type;
      return {
        0: '未设置',
        1: "\u9ED1\u540D\u5355".concat(black_movies_count, "\u4E2A"),
        2: "\u767D\u540D\u5355".concat(black_movies_count, "\u4E2A")
      }[movie_setting_type] || '未设置';
    },
    hasExportRole: function hasExportRole() {
      var authEnum = {
        orderDetails: '/orders/card-rule-extend/cinemas-v2-export',
        channelCardTypeManage: '/orders/card-rule-extend/cinemas-v2-common-export',
        saleCardTypeManage: '/orders/card-rule-extend/cinemas-v2-sale-export'
      };
      var keys = Object.keys(authEnum);
      if (keys.includes(this.menuType)) {
        // 产品要求 只需要在这三个页面中判断权限即可
        var rolePath = authEnum[this.menuType];
        return this.$hasBtnRoles(rolePath);
      }
      return false;
    }
  }
};